import { useMemo, useState } from "react";
import { Stack } from "@bookingcom/bui-react";
import type { Airline } from "../../types";
import { AirlinePickerList } from "./AirlinePickerList";
import { AirlinePickerInput } from "./AirlinePickerInput";

type AirlinePickerContentProps = {
  airlines?: Airline[];
  value?: string;
  onChange: (airline: Airline) => void;
};

export const AirlinePickerContent = ({ airlines = [], value, onChange }: AirlinePickerContentProps) => {
  const [query, setQuery] = useState("");

  const filteredAirlines = useMemo(() => {
    if (!query) return airlines;

    const lowerCaseQuery = query.toLowerCase();
    return airlines?.filter(
      ({ code, name }) => code.toLowerCase().includes(lowerCaseQuery) || name.toLowerCase().includes(lowerCaseQuery)
    );
  }, [query, airlines]);

  return (
    <Stack gap={0}>
      <AirlinePickerInput setQuery={setQuery} />
      <AirlinePickerList airlines={filteredAirlines} value={value} onClick={onChange} />
    </Stack>
  );
};
